<template>
    <div class="message__wrapper">
      <img class="message__image" src="#" alt="image">
      <p class="message__title">No pudimos guardar los cambios. Por favor, inténtalo de nuevo.</p>
    </div>
  </template>
  
  <script>
  export default {
    name:"Notifications",
    props: {
      image: null,
      text: String
    }
  }
  </script>